import { HttpClient, HttpHeaders } from '@angular/common/http';
import { KeyValue } from 'app/shared/models/standard.models';
import { Observable } from 'rxjs';
import * as api from '../shared/api/apihandler';
import { Task } from './models';
import { OrderHistory } from 'app/shared-html-components/klarpris-purchases/klarpris-purchase.data';

export class CaseFunctions {
    constructor(private http: HttpClient) { }

    getCase(id) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Case/CaseDetails/' + id, { headers });
    }

    getCaseStages() {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetCaseStages', { headers });
    }

    setCaseStage(caseId: string, stageId: string) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        if (!!stageId) { 
            return this.http.patch(api.jubloApi + 'api/Website/Case/SetCaseStage/' + caseId + '?StageId=' + stageId, {}, { headers });
        }
        else { 
            return this.http.patch(api.jubloApi + 'api/Website/Case/SetCaseStage/' + caseId + '?StageId=' + null, {}, { headers });
        }
    }

    getOfferStatuses():Observable<KeyValue[]> {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get<KeyValue[]>(api.jubloApi + 'api/Website/Offer/OfferStatusList', { headers })
      }

    getCaseChannels(){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetCaseChannels', { headers })
    }

    getCaseProperties(caseId:string){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetCaseProperties/' + caseId, { headers })
    }

    removeContactFromCase(caseId: string) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.http.patch(api.jubloApi + '/api/Website/Case/RemoveContact/' + caseId, {}, { headers });
    }

    statusNameById(statusId:String, statuses:KeyValue[]){
        if(!!statuses && !!statusId ) return statuses.find(x => x.key == statusId).value;
        else {
            return ''

        }

    }

    statusColorById(statusId){
        switch (statusId.toLowerCase()) {
        case '8850aee1-48a3-48a6-aa98-2e1597b7b1d7': return 'badge-success'; // Open
        case '6991f0ea-bdb5-4e30-868f-46c43d712e9b': return 'badge-primary'; // NeedPlanning
        case '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0': return 'badge-warning'; // Canceled
        case '7bccdf15-ad49-4cc9-b358-68e08287f32f': return 'badge-secondary'; // Posted
        case 'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7': return 'badge-info'; // Offer
        case '5962d8ea-8fa0-4346-836d-a069901a95a2': return 'badge-dark'; // AwaitingAnswer
        case '71c47a4a-f277-42c5-8d88-b17db5a4f78f': return 'badge-success'; // Custom/Other
        case 'a693c47f-9685-4bb6-bf6e-bcab86cb88de': return 'badge-light'; // Closed
        default: return 'badge-success';
        }
    }

    hasClearPrice(){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/PackageDistributor/PackageDistributorOffer', { headers })
    }

    getUnit(id){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Package/' + id, { headers })
    }

    getOrderHistory(caseId:string){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get<Array<OrderHistory>>(api.jubloApi + 'api/Website/KlarPris/GetKpOrderHistory/' + caseId, { headers })
    }

    getOffer(offerId:string){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Website/Offer/' + offerId, { headers })
    }

    getCaseTimes(caseId:string):Observable<Task>{
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return new Observable(obs => {
            this.http.get(api.jubloApi + 'api/Website/Case/GetCaseTasks/' + caseId, { headers }).subscribe({
                next:(data:Task[])=> {
                    let nextTask = data.filter(x => new Date(x.endDateTime) > new Date()).sort((a,b) => new Date(a.endDateTime) < new Date(b.endDateTime) ? -1 : 1)
                    obs.next(nextTask.length ? nextTask[0] : null);
                    obs.complete();
                },
                error:(err) => {
                    obs.error(err);
                    obs.complete();
                }
            })
        })
    }
}

